
import { IScrBaseResponse, ScrBaseResponse } from "../services/base.service";
import { Account } from "./account.model";
import { StringOrPhoneNumber } from "./common.model";
import { ShortCodeStatus } from "./constants";
import { Field, ObjectType } from "./decorators";
import { Lease } from "./lease.model";


export class TransferResult extends ScrBaseResponse {
    incomingTransfer!: transfer;
    outgoingTransfer!: transfer;
    scStatus!: string;
}

export class transfer  {
    transfer!: Transfer[];
    totalCount!: number;
}



export class TransferAccept {
    public action = 'acceptTransfer';
    fromAccountId!: number;
    scId!: number;
    transferId!: number;
    monthlyBilling!: boolean;
    autorenew!: boolean;
    transferType?: string;
}


@ObjectType()
export class ShortCode {
    @Field() scId!: number;
    @Field() name!: string;
    @Field() scStatus!: ShortCodeStatus;
    @Field() latestLeaseId?: number;
    @Field() scStatusUpdateTime!: Date;
    @Field() updateTime!: Date;

}

export class LookupResult extends Lease {
  scStatus!: string;
}

export interface ShortCodeDetails {

    orderId: number,
    scId: number,
    applicationType: string,
    term: number,
    autorenew: boolean,
    selectType: string,
    leaseStatus: string,
    scExpirationDate: string,
    ageDate: string;
    firstName: string,
    lastName: string,
    address1: string,
    address2: string,
    city: string,
    state: string,
    zip: string,
    country: string,
    phone: StringOrPhoneNumber,
    phoneExtension: string;
    email: string,
    billingFirstName: string,
    billingLastName: string,
    billingAddress1: string,
    billingAddress2: string,
    billingCity: string,
    billingState: string,
    billingZip: string,
    billingCountry: string,
    billingPhone: StringOrPhoneNumber,
    billingPhoneExtension: string;
    billingEmail: string,
    company: string,
    cpId: number,
    applicationProvider: string,
    aggregatorName: string,
    scStatus: string,
    suppressExpiryEmail: boolean;
    leaseType: string,
    transferStatus: string,
    transferId: number,
    toAccountId: string

    reservedBy?: Account[];

    allOrderIds: number[],
    accountId?: number,

    forPoliticalCampaign: boolean,
    politicalCampaignStatus: string,
    politicalCampaignComments: string,
    politicalCampaignType: string,
    politicalCampaignInfo: string,
    fecId: string,

    parkedCode: boolean;
    demoCode: boolean;
}
export interface ShortCodeHistory {
    accountId: number;
    applicationType: string;
    approvalDate: string;
    autorenew: boolean;
    billingEmail: string;
    billingFirstName: string;
    billingLastName: string;
    company: string;
    createTime: string;
    email: string;
    endDate: string;
    deactivateDate: string;
    ageDate: string;
    firstName: string;
    forPoliticalCampaign: boolean;
    lastName: string;
    leaseStatus: string;
    leaseType: string;
    previousStatus: string;
    orderId: number;
    orderInitiator: string;
    originalOrderId: number;
    parentOrderId: number;
    price: string;
    scExpirationDate: string;
    reactivateDate: string;
    scId: number;
    selectType: string;
    startDate: string;
    statusReason: string;
    suppressExpiryEmail: boolean;
    term: number;
    paymentMethod: string;
}

@ObjectType()
export class Transfer {
    @Field({q:["sdlist", "complete"]}) transferId!: number;
    @Field({q:["sdlist", "complete"]}) scId!: number;
    @Field({q:["sdlist", "complete"]})  fromAccountId!: number;
    @Field({q:["sdlist", "complete"]})  toAccountId!: number;
    @Field({q:["sdlist", "complete"]})  toOrderId!: number;
    @Field({q:["sdlist", "complete"]})  fromOrderId!: number;
    @Field({q:["sdlist"]}) updateTime!: string;
    @Field({q:["sdlist"]}) createTime!: string;
    @Field({q:["sdlist", "complete"]})  transferTime!: string;
    @Field({q:["sdlist", "complete"]})  transferStatus!: string;
    @Field({q:["sdlist", "complete"]})  comments!: string;
    @Field({q:["sdlist", "complete"]})  initiatedBy!: string;
    @Field({q:["sdlist", "complete"]})  respondedBy!: string;
    @Field({q:["sdlist", "complete"]})  initiatedDate!: string;
    @Field({q:["sdlist", "complete"]})  respondedDate!: string;
    @Field({q:["sdlist", "complete"]})  toCompany!: string;
    @Field({q:["sdlist", "complete"]})  fromCompany!: string;
    @Field({q:["sdlist", "complete"]})  transferType!: string;
    @Field({q:["sdlist"]})  transferTypeRequested!: string;
    @Field({q:["sdlist"]})  cancelledBy!: string;
    @Field({q:["sdlist"]})  cancelledDate!: string;
    @Field({q:["sdlist"]})  fromLeaseType!: string;
    @Field({q:["sdlist"]})  statusReason!: string;

    // not sure what these are.
    autorenewRequested!: string;
    monthlyBillingRequested!: string;
    toAutorenew!: string;

    // added in back end for query.
    @Field({q:["sdlist"]}) leaseExpirationDate!: string;
    @Field({q:["sdlist"]}) mbOptOutDate!: string;
    @Field({q:["sdlist"]}) leaseType!: string;
    @Field({q:["sdlist"]}) leaseStatus!: string;
    @Field({q:["sdlist"]}) leaseTerm!: number;
    @Field({q:["sdlist"]}) monBillEnabled!: number;

    // not returned by server.
    isExpansionDisplay?: boolean = false;
}

export class ReportSuspiciousActivity {

    orderId?: number;
    scId?: number;
    applicationType?: string;
    currentLease?: string;
    currentLeasecompanyname?: string;
    contentProviderCompanyName?: string;
    aggregatorCompanyName?: string;
    applicationProviderCompanyName?: string;
    brand?: string;
    activityType?: string[];
    description?: string;
    shortCodeStatus?: string;
    aggregatorId?: number;
    sharedShortCode?: boolean;
}

export class ReportSuspiciousActivityRequest {
    activityTypes?: string[];
    shortCode?: number;
    aggregatorId?: number;
    cpCompanyName?: string;
    applicationProvider?: string;
    brand?: string;
    lesseeCompany?: string;
    description?: string;
    sharedShortCode?: boolean;
}

export class UpdateSuspiciousActivityRequest {
    status!: string;
    comment!: string;
    sharedShortCode?: boolean;
}

@ObjectType()
export class SuspiciousActivity {

    @Field() activityId!: number;
    @Field() activityTypes!: string[];
    @Field() shortCode!: number;
    @Field() aggregatorId!: number;
    @Field() cpCompanyName!: string;
    @Field() applicationProvider!: string;
    @Field() brand!: string;
    @Field() lesseeCompany!: string;
    @Field() description!: string;
    @Field() createTime!: Date;
    @Field() createdBy!: string;
    @Field() createdByCompany!: string;
    @Field() updateTime!: Date;
    @Field() updatedBy!: string;
    @Field() updatedByAccountId?: number;
    @Field() updatedByCompany?: string;
    @Field() sharedShortCode?: boolean;

    public statuses!: SuspiciousActivityStatus[];

    // local only
    public status?: string;
    public aggregatorName?: string;
}

@ObjectType()
export class SuspiciousActivityStatus {

    @Field() public statusId!: number;
    @Field() public activityId!: number; // back pointer.
    @Field() public status!: string;
    @Field() public latestStatus!: boolean;
    @Field() public comment?: string;
    @Field() public createTime!: Date;
    @Field() public createdBy!: string;
    @Field() public createdByAccountId!: number;
    @Field() public createdByCompany!: string;
}
  

export interface SuspiciousActivityResponse extends IScrBaseResponse {
    activity?: ReportSuspiciousActivity;
}

export interface SuspiciousActivityListResponse extends IScrBaseResponse {
    activities?: ReportSuspiciousActivity[];
}

export class TypeCode {
    code!: string;
    description!: string;
}

export class SuspiciousActivityList {
    activityId?: number;
    activityTypes?: string[];
    shortCode?: number;
    aggregatorId?: number;
    cpCompanyName?: string;
    applicationProvider?: string;
    brand?: string;
    lesseeCompany?: string;
    description?: string;
    createTime?: string;
    createdBy?: string;
    createdByCompany?: string;
    statuses?: Status[];
    createdByAccountId?: number;
    sharedShortCode?: boolean;
}

export class Status {
    statusId?: number;
    activityId?: number;
    status?: string;
    latestStatus?: boolean;
    createTime?: string;
    createdByAccountId?: number;
    createdByCompany?: string;
}

export class SuspiciousActvityVO {
    reportDate?: string;
    scId?: number;
    leesee?: string;
    activityType?: string;
    status?: string;
}